import { routerContext } from '@lib/router'
import { walletTermsQueryOptions } from '@src/queryOptions/terms'

export const ensureUserTermsQueryData = (context: typeof routerContext) => {
  const storeState = context.store.getState().onboarding
  const { essentialFlow } = storeState
  return context.queryClient.fetchQuery(
    walletTermsQueryOptions({
      isPayCardAccount: essentialFlow,
    })
  )
}
